export const requestPointerLock = async () => {
  try {
    await (window.document.body.requestPointerLock() as unknown as Promise<void>);
  } catch (e) {
    console.warn(e);
  }
};
